module.exports = __webpack_public_path__ + "media/images/icons/spotify-601b24730267e75945bb85648c67e446.svg";